import endpoints from 'api/endpoints';

export default id => ({
  url: endpoints.getSingleTopicUrl(id),
  queryKey: `delete${endpoints.getSingleTopicUrl()}`,
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: 'application/json',
    },
    method: 'DELETE',
  },
  update: {
    topic: prevResult => prevResult.filter(item => item.get('_id') !== id),
  },
  updateResult: {
    topics: prevResult => prevResult.filter(item => item !== id),
  },
});
